import { make } from 'vuex-pathify'
import makeTableCommonActions from '../../utils/vuexModuleConstructor/vuexTableCommonActionsMaker'
import makeTableCommonGetters from '../../utils/vuexModuleConstructor/vuexTableCommonGettersMaker'
import makeTableCommonState from '../../utils/vuexModuleConstructor/vuexTableCommonStateMaker'

const remoteEntityName = 'users.login_attempts'

const state = {
  ...makeTableCommonState()
}

const getters = {
  pageTitle: () => 'Login attempts',

  controlledActions: () => {
    return { // 0 if anyone can. -1 if disabled (i.e., no one can); 'creator' -- if only user with id same as created_by_user_id
      create: -1,
      fetch: 27,
      update: -1,
      delete: -1,
      downloadList: 27,
      uploadList: -1
    }
  },

  controllers: () => {
    return {
      get create () { return remoteEntityName + '_create' }, // override controller names if they are different
      get fetch () { return remoteEntityName + '_fetch' },
      get update () { return remoteEntityName + '_update' },
      get delete () { return remoteEntityName + '_delete' }
    }
  },

  columns: () => {
    return [
      { name: 'id', label: 'ID', style: 'width:50px', field: 'id', isNumeric: true },
      { name: 'login', label: 'Login', field: 'login', align: 'left', uiFilterTypes: ['selectedValuesFilter', 'textFilters'] },
      { name: 'ip_address', label: 'IP address', field: 'ip_address', align: 'left', uiFilterTypes: ['selectedValuesFilter', 'textFilters'] },
      { name: 'result', label: 'Result', field: 'result', align: 'left', uiFilterTypes: ['selectedValuesFilter'] },
      { name: 'created_at', label: 'Time', field: 'created_at', isDateTime: true, uiFilterTypes: ['dateFilters'] }
    ]
  },

  remoteEntityName: () => remoteEntityName,

  ...makeTableCommonGetters({ remoteEntityName })
}

const mutations = make.mutations(state)
const namespaced = true

const actions = {
  ...makeTableCommonActions()
}

export default { state, actions, mutations, getters, namespaced }
